var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66665 9.66667C6.10867 9.66667 6.5326 9.49107 6.84516 9.17851C7.15772 8.86595 7.33331 8.44203 7.33331 8C7.33331 7.08 6.99998 6.66667 6.66665 6C5.95198 4.57133 6.51731 3.29733 7.99998 2C8.33331 3.66667 9.33331 5.26667 10.6666 6.33333C12 7.4 12.6666 8.66667 12.6666 10C12.6666 10.6128 12.5459 11.2197 12.3114 11.7859C12.0769 12.352 11.7332 12.8665 11.2998 13.2998C10.8665 13.7332 10.352 14.0769 9.78584 14.3114C9.21965 14.546 8.61282 14.6667 7.99998 14.6667C7.38714 14.6667 6.78031 14.546 6.21412 14.3114C5.64794 14.0769 5.13349 13.7332 4.70015 13.2998C4.26681 12.8665 3.92306 12.352 3.68854 11.7859C3.45402 11.2197 3.33331 10.6128 3.33331 10C3.33331 9.23133 3.62198 8.47067 3.99998 8C3.99998 8.44203 4.17557 8.86595 4.48814 9.17851C4.8007 9.49107 5.22462 9.66667 5.66665 9.66667Z",
    stroke: "#DBFF00",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.821a554fb9cf77b86bcd20c382971ff7.svg";
export { ForwardRef as ReactComponent };